var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":_vm.getImgUrl(_vm.bannerImage)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }